
import { User, Bot, Check, Loader2 } from 'lucide-react';

type Props = {
 user:any
}
export const Header = ({user}: Props) => {
    return ( 
<div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center">
              <User className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-800">
                ¡Hola, {user?.firstName}!
              </h1>
              <p className="text-gray-600">
                Elige la personalidad de tu chatbot
              </p>
            </div>
          </div>
        </div>
    );
}